import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
var _excluded = ["id", "stripe", "bordered", "innerBordered", "outerBordered", "size", "className", "rowClassName", "onChange", "bottomRight", "noHeader", "affixHeader", "formatterCanBeOverwritten"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import { getValue } from '../tools/util';
import { isPropsEqual } from '../tools/isEqual';
import ConfigConsumerProvider from '../ConfigConsumerProvider';
import RowSelection from './plugin/RowSelection';
import { ON_TH_CLICK, TH_DECORATOR, RAW, ORIGIN, TD_DECORATOR, mapColumns as _mapColumns, EMPTY_ROW } from './common';
import Sorter from './plugin/Sorter';
import Filter from './plugin/Filter';
import Pagination from './plugin/Pagination';
import Tree from './plugin/Tree';
import SummaryRow from './plugin/SummaryRow';
import Expandable from './plugin/Expandable';
import PlaceholderColumn from './plugin/PlaceholderColumn';
import TableKernel from './TableKernel';
import HeadDescription from './plugin/HeadDescription';
import Drag from './plugin/Drag'; // 默认插件

var defaultPlugins = [SummaryRow, HeadDescription, Sorter, Filter, Pagination, Tree, Expandable, RowSelection, PlaceholderColumn, Drag];

var Table = /*#__PURE__*/function (_Component) {
  _inherits(Table, _Component);

  var _super = _createSuper(Table);

  function Table(props) {
    var _this;

    _classCallCheck(this, Table);

    _this = _super.call(this, props);
    _this.cxt = {};
    return _this;
  }

  _createClass(Table, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !isPropsEqual(this.props, nextProps, ['columns', 'dataSource']);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          dataSource = _this$props.dataSource,
          columns = _this$props.columns;
      var rowClassNameList = [];

      var _this$props2 = this.props,
          id = _this$props2.id,
          stripe = _this$props2.stripe,
          bordered = _this$props2.bordered,
          innerBordered = _this$props2.innerBordered,
          outerBordered = _this$props2.outerBordered,
          size = _this$props2.size,
          className = _this$props2.className,
          _rowClassName = _this$props2.rowClassName,
          onChange = _this$props2.onChange,
          bottomRight = _this$props2.bottomRight,
          noHeader = _this$props2.noHeader,
          affixHeader = _this$props2.affixHeader,
          formatterCanBeOverwritten = _this$props2.formatterCanBeOverwritten,
          otherProps = _objectWithoutProperties(_this$props2, _excluded);

      var bottomRightList = [];
      var dragProps = {};
      columns = _mapColumns(columns, function (raw) {
        var _objectSpread2;

        return _objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, RAW, raw), _defineProperty(_objectSpread2, ORIGIN, true), _objectSpread2), formatterCanBeOverwritten ? _objectSpread(_objectSpread({}, raw.formatter ? raw.formatter(raw) : {}), raw) : _objectSpread(_objectSpread({}, raw), raw.formatter ? raw.formatter(raw) : {}));
      }); // 处理插件

      defaultPlugins.forEach(function (plugin) {
        var pluginResult = plugin({
          dataSource: dataSource,
          columns: columns,
          change: function change(action, value) {
            onChange({
              action: action,
              value: value,
              props: _this2.props
            });
          },
          cxt: _this2.cxt,
          update: function update() {
            _this2.forceUpdate();
          },
          mapColumns: function mapColumns(mapper) {
            return _mapColumns(columns, function (raw, index) {
              var newRow = mapper(raw, index);

              if (!newRow) {
                return raw;
              }

              var result = _objectSpread(_objectSpread({}, raw), newRow); // 处理装饰器和点击效果


              [TD_DECORATOR, TH_DECORATOR, ON_TH_CLICK].forEach(function (symbol) {
                var field = newRow[symbol];

                if (field) {
                  result[symbol] = [].concat(raw[symbol] || []).concat(field);
                }
              });
              return result;
            });
          }
        }, otherProps) || {};

        var _dataSource$columns$p = _objectSpread({
          dataSource: dataSource,
          columns: columns
        }, pluginResult);

        dataSource = _dataSource$columns$p.dataSource;
        columns = _dataSource$columns$p.columns;
        dragProps = _dataSource$columns$p.dragProps;
        var pluginRowClassName = pluginResult.rowClassName,
            pluginBottomRight = pluginResult.bottomRight;

        if (pluginRowClassName) {
          rowClassNameList.push(pluginRowClassName);
        }

        if (pluginBottomRight) {
          bottomRightList.push(pluginBottomRight);
        }
      });
      return /*#__PURE__*/React.createElement(ConfigConsumerProvider, {
        size: size,
        tableBordered: bordered && !innerBordered && !outerBordered
      }, function (_ref) {
        var configSize = _ref.size,
            tableBordered = _ref.tableBordered,
            tableAffixHeaderTop = _ref.tableAffixHeaderTop;
        return /*#__PURE__*/React.createElement(TableKernel, _extends({
          id: id,
          tableProps: _this2.props,
          affixHeader: affixHeader === true ? tableAffixHeaderTop !== null && tableAffixHeaderTop !== void 0 ? tableAffixHeaderTop : true : affixHeader
        }, otherProps, {
          size: configSize,
          className: classNames(className, {
            'jmtd-table-stripe': stripe,
            'jmtd-table-bordered': tableBordered,
            'jmtd-table-no-header': noHeader,
            'jmtd-table-custom-bordered': innerBordered
          }),
          rowClassName: function rowClassName() {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            return [_rowClassName].concat(rowClassNameList).map(function (getRowClassName) {
              return getValue.apply(void 0, [getRowClassName].concat(args));
            });
          },
          dataSource: dataSource,
          columns: columns,
          bottomRight: bottomRightList.length ? /*#__PURE__*/React.createElement(React.Fragment, null, bottomRightList.map(function (comp, i) {
            return /*#__PURE__*/React.createElement(Fragment, {
              key: i
            }, comp);
          }), bottomRight) : null,
          dragProps: dragProps
        }));
      });
    }
  }]);

  return Table;
}(Component);

export { Table as default };
Table.EMPTY_ROW = EMPTY_ROW;
Table.propTypes = {
  id: PropTypes.string,
  columns: PropTypes.array,
  dataSource: PropTypes.array,
  size: PropTypes.oneOf(['mini', 'small', 'middle', 'large']),
  bordered: PropTypes.bool,
  innerBordered: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  outerBordered: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  loading: PropTypes.bool,
  pagination: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  stripe: PropTypes.bool,
  affixHeader: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  // 是否吸顶
  rowClassName: PropTypes.func,
  className: PropTypes.string,
  emptyDescription: PropTypes.node,
  bottomLeft: PropTypes.node,
  bottomRight: PropTypes.node,
  onChange: PropTypes.func,
  sortDirections: PropTypes.array,
  noHeader: PropTypes.bool,
  childrenColumnName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  hasChildrenColumnName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  childrenExpandedStateName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  noAutoRowHeight: PropTypes.bool,
  rowKey: PropTypes.oneOfType([PropTypes.string, PropTypes.symbol, PropTypes.func]),
  formatterCanBeOverwritten: PropTypes.bool // 允许覆盖formatter

};
Table.defaultProps = {
  id: null,
  columns: [],
  size: null,
  bordered: undefined,
  innerBordered: undefined,
  outerBordered: undefined,
  loading: false,
  pagination: false,
  affixHeader: false,
  stripe: false,
  dataSource: [],
  rowClassName: function rowClassName() {
    return null;
  },
  className: '',
  emptyDescription: undefined,
  bottomLeft: null,
  bottomRight: null,
  onChange: function onChange() {},
  sortDirections: ['ascend', 'descend', 'disordered'],
  noHeader: false,
  childrenColumnName: 'children',
  hasChildrenColumnName: 'hasChildren',
  childrenExpandedStateName: 'childrenExpanded',
  noAutoRowHeight: false,
  rowKey: null,
  formatterCanBeOverwritten: false
};